export default "__VITE_ASSET__C5OflVj___"